import axios from "axios";

const axiosInstanceInterceptor = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});

// Add a response interceptor
axiosInstanceInterceptor.interceptors.response.use(
  (response) => {
    // If the response is successful, simply return it
    return response;
  },
  (error) => {
    // Check if the error response status is 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized access - logging out...");
      // Clear local storage
      localStorage.clear();
      // Redirect to login page
      //window.location.href = "/login";
      window.location.href = window.location.origin + window.location.pathname;
    }
    // Reject the promise with the error
    return Promise.reject(error);
  }
);

export default axiosInstanceInterceptor;